import styled from 'styled-components';
import defaultTheme from '../theme';
import {pulse} from '../common/animations';

const fillFunc = (props) => {
    const {speaking, invalid, theme} = props;

    if (speaking) {
        return theme.headerBgColor;
    }
    return invalid ? '#E53935' : '#4a4a4a';
};

const SubmitButton = styled.button`
  background-color: transparent !important;
  border: 0 !important;
  border-bottom-right-radius: 10px !important;
  box-shadow: none !important;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')} !important;
  fill: ${fillFunc} !important;
  color: ${fillFunc} !important;
  line-height: 1!important;
  font-size: 1em!important;
  opacity: ${props => (props.disabled && !props.invalid ? '.5' : '1')} !important;
  outline: none !important;
  padding: 14px 16px 12px 16px !important;
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  &:before {
    content: '' !important;
    position: absolute !important;
    width: 23px !important;
    height: 23px !important;
    border-radius: 50% !important;
    animation: ${({theme, speaking}) =>
    speaking ? `${pulse(theme.headerBgColor)} 2s ease infinite` : ''} !important;
  }
  &:not(:disabled):hover {
    opacity: 0.7 !important;
  }
`;

SubmitButton.defaultProps = {
    theme: defaultTheme,
};

export default SubmitButton;
